import { atom } from 'recoil';

export const currentUser = atom({
  key: 'currentUser',
  default: {
    idClient: null,
    id: null,
    token: null,
    role: null,
    name: null
  }
});

export const currentUserProducts = atom({
  key: 'currentUserProducts',
  default: []
});
